<template>
  <div>
    <footer class="footer">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12 footer-copyright text-center">
            <div class="mb-0">Copyright 2025 © 
              <span ><a href="https://futurebangladeshyouwant.com/" target="_blank" rel="noopener noreferrer" style="color: #F7902E;">Future Bangladesh You Want</a></span>

            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
  import json from '../data/menu';

  export default {
    name: 'footerpage',
    data() {
      return {
        customizer: false,
        data:
          'data:text/json;charset=utf-8,' +
          encodeURIComponent(JSON.stringify(json)),
      };
    },
  };
</script>
